import { UnreachableError } from 'base/helpers';
import { z } from 'zod';

const projectsFilterSchema = z.enum(['user', 'team']);

export type DashboardRoute = {
  path: 'dashboard';
  projectsFilter?: z.infer<typeof projectsFilterSchema>;
};

export function maybeParseDashboardRoute(
  url: Pick<URL, 'searchParams' | 'pathname'>,
): DashboardRoute | undefined {
  if (url.pathname === '/dashboard') {
    const pf = projectsFilterSchema.safeParse(url.searchParams.get('projects'));
    return {
      path: 'dashboard',
      projectsFilter: pf.success ? pf.data : undefined,
    };
  }
}

export function dashboardRouteToUrl(route: DashboardRoute): string {
  switch (route.path) {
    case 'dashboard':
      const search = new URLSearchParams();
      if (route.projectsFilter) {
        search.set('projects', route.projectsFilter);
      }
      return `/dashboard?${search}`;
    default:
      throw new UnreachableError(route.path);
  }
}
